export default [
  {
    path: '/orders',
    name: 'Orders',
    meta: {
      requireAuth: true,
      requireFields: true,
    },
    component: () => import('@/views/Orders/index.vue'),
  },
]
